import axios from "axios";
import { IQueueTotal } from "../types/queue";

export const QueueTransport = {
    getQueuesSize: async (): Promise<IQueueTotal> => {
        const { data } = await axios.get<IQueueTotal>(`/sqs/queueSize`, {});
        return data;
    },
};
